'use client'
import { memo, type PropsWithChildren } from 'react'

import { SubSectionTitle } from '@/components/common/SubSectionTitle'

export interface InterestRateModelSectionLayoutProps extends PropsWithChildren {
  utilizationTableSlot: React.ReactNode
  utilizationChartSlot: React.ReactNode
}

const InterestRateModelSectionLayout = ({
  utilizationTableSlot,
  utilizationChartSlot
}: InterestRateModelSectionLayoutProps) => {
  return (
    <div className="gap-sm flex grow flex-col">
      <div className="gap-2xs flex items-center">
        <SubSectionTitle>IRM Breakdown</SubSectionTitle>
      </div>
      <div className="gap-x-sm gap-y-sm grid grid-cols-2 max-lg:grid-cols-1">
        {utilizationTableSlot}
        {utilizationChartSlot}
      </div>
    </div>
  )
}

export default memo(InterestRateModelSectionLayout)
